module.exports = __webpack_public_path__ + "img/ele4.9afd252e.jpg";